import React from 'react'
import classNames from 'classnames'

export type DateTextProps = React.ComponentPropsWithoutRef<'time'>

export const DateText = ({ className, ...rest }: DateTextProps) => (
  <time className={classNames('testimonial-card__date', className)} {...rest} />
)
